import React from "react";
import history from "../../router/history";
import {LoadingButton} from "../LoadingButton";

class PageStepsCard extends React.Component {
  render() {

    let buttonPreviusStep = "";
    if(this.props.step > 1) {
      buttonPreviusStep = (
        <button type="button" className="btn btn-link" onClick={() => this.props.history.goBack()}>
          Tillbaka
        </button>
      );
    }
    
    let buttonNextStep = (
      <button type="button" className="btn btn-primary" onClick={() => this.props.handleSubmit()}>
        Gå vidare
      </button>
    );

    if(this.props.step == 3) {
      buttonNextStep = (
        <button type="button" className="btn btn-primary" onClick={() => this.props.handleSubmit()}>
          Bekräfta köp
        </button>
      );
    };
    
    return (
      <div className="card mt-4">
        <div className="card-footer">
          <div className="d-flex justify-content-between">
            <div>{ buttonPreviusStep }</div>            
            { !this.props.sendingMail ? buttonNextStep : <LoadingButton text="Skickar"/>}
          </div>
        </div>
      </div>
    );
  }
}

export default PageStepsCard;
